import React, { useState } from "react"
import styled from "styled-components"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { resendConfirmationEmail } from "../../../services/user/user"
import { Intro, SubmitButton, Title } from "./Styles"
import { LOGIN_FORM } from "../../../context/form/formTypes"

const StyledTitle = styled(Title)`
  margin-bottom: 42px;
  margin-top: -2px;
  text-align: center;
`

const Content = styled.div`
    margin-bottom: ${props => props.last ? "0" : "20px"};
`

const Email = styled.strong`
    ${fonts.helveticaNeueMedium};
    font-size: inherit;
    line-height: inherit;
    color: ${colors.green};
`

const EmailLink = styled.a`
    ${fonts.helveticaNeueMedium};
    font-size: inherit;
    line-height: inherit;
    color: ${colors.green};
    cursor: pointer;
    text-decoration: none;
`

const StyledButton = styled(SubmitButton)`
    margin-top: 48px;
`

const ResendLinkWrapper = styled.div`
    margin-bottom: 14px;
    display: flex;
    justify-content: center;
`

const ResendLink = styled.div`
    ${fonts.helveticaNeue};
    color: ${colors.grey};
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 0.19px;
    text-align: center;
    &:last-child {
        margin-left: 3px;
    }

    button {
        ${fonts.helveticaNeueMedium};
        font-size: inherit;
        line-height: inherit;
        color: ${colors.green};
        cursor: pointer;
        text-decoration: none;
        border: none;
        outline: none;
        background: transparent;
        margin: 0;
        padding: 0;
        display: inline-block;
        text-decoration: underline;
    }
`

const Confirm = ({ t, email, fullName, setContent }) => {

    const [sent, setSent] = useState(false)

    const handleEmailResend = async () => {
        if(!sent) {
            try {
                const data = {email, fullName}
                await resendConfirmationEmail(data)
                setSent(true)
            } catch (error) {
                console.error(error)
            }
        }
    }

    const switchToLogin = () => {
        setContent(LOGIN_FORM)
    }

    return (
        <div>
            <StyledTitle>{t("account.confirm_title")}</StyledTitle>
            <Content>
                <Intro>{t("account.confirm_info1")}<Email>{email}</Email></Intro>
                <Intro>{t("account.confirm_info2")}</Intro>
            </Content>
            <Content last>
                <Intro>{t("account.confirm_info3")}</Intro>
                <Intro i18nKey={"account.confirm_info4"}>
                    The sender is <EmailLink href="mailto:info@kimai.com">info@kimai.com</EmailLink>
                </Intro>
            </Content>
            <StyledButton onClick={switchToLogin}>
                {t("account.confirm_login_button")}
            </StyledButton>
            <ResendLinkWrapper i18nKey={"account.confirm_resend"} >
                <ResendLink>Didn’t receive? <button onClick={handleEmailResend} >Resend the email</button></ResendLink>
                { sent && <ResendLink>{t("account.confirm_sent")}</ResendLink> }
            </ResendLinkWrapper>

        </div>
    )
}

export default withTranslation()(Confirm)
